import React from 'react';
import { BiRupee } from 'react-icons/bi';

const CurrencyIcon = (props) => {
  return <BiRupee {...props}/>;
};
export default CurrencyIcon;
